/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const AR_SUMMARY_QTR_ALL_TABLE = 'AR_SUMMARY_QTR_ALL_TABLE';
export const AR_SUMMARY_UNALLOCATED_QTR_TABLE =
  'AR_SUMMARY_UNALLOCATED_QTR_TABLE';
export const AR_SUMMARY_ALL_QTR_TABLE = 'AR_SUMMARY_ALL_QTR_TABLE';
export const AR_SMRY_FOR_QTR_SINGLE = 'AR_SMRY_FOR_QTR_SINGLE';
export const AR_SUMMARY_ALL_QTR_VALUE = 'AR_SUMMARY_ALL_QTR_VALUE';
export const ACC_REBATE_LIST = 'ACC_REBATE_LIST';
export const ALL_FLD_DATA = 'ALL_FLD_DATA';
export const ACC_REBATE_PGM_NAME = 'ACC_REBATE_PGM_NAME';
export const AR_SUMMERY_QTR_ALL_FIELD_CLEAR_REDUX =
  'AR_SUMMERY_QTR_ALL_FIELD_CLEAR_REDUX';
